/* tslint:disable */

declare var Object: any;
export interface MedicionEstadoInterface {
  "idmedicionestado"?: number;
  "idstate"?: number;
  "idusermongo"?: string;
  "idmedicionmongo"?: string;
  "idmedicion"?: number;
  "idmedicionestadomongo"?: string;
  "fechacreacion"?: Date;
  "idusuario"?: number;
}

export class MedicionEstado implements MedicionEstadoInterface {
  "idmedicionestado": number;
  "idstate": number;
  "idusermongo": string;
  "idmedicionmongo": string;
  "idmedicion": number;
  "idmedicionestadomongo": string;
  "fechacreacion": Date;
  "idusuario": number;
  constructor(data?: MedicionEstadoInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `MedicionEstado`.
   */
  public static getModelName() {
    return "MedicionEstado";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of MedicionEstado for dynamic purposes.
  **/
  public static factory(data: MedicionEstadoInterface): MedicionEstado{
    return new MedicionEstado(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'MedicionEstado',
      plural: 'MedicionEstados',
      path: 'MedicionEstados',
      idName: 'idmedicionestado',
      properties: {
        "idmedicionestado": {
          name: 'idmedicionestado',
          type: 'number'
        },
        "idstate": {
          name: 'idstate',
          type: 'number'
        },
        "idusermongo": {
          name: 'idusermongo',
          type: 'string'
        },
        "idmedicionmongo": {
          name: 'idmedicionmongo',
          type: 'string'
        },
        "idmedicion": {
          name: 'idmedicion',
          type: 'number'
        },
        "idmedicionestadomongo": {
          name: 'idmedicionestadomongo',
          type: 'string'
        },
        "fechacreacion": {
          name: 'fechacreacion',
          type: 'Date'
        },
        "idusuario": {
          name: 'idusuario',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/lbsdk/models/MedicionEstado.ts